export default __webpack_public_path__ + "static/media/bg-gradient-home.e6daeada.png";